export class DataHubStore {
    constructor() {
        Object.defineProperty(this, "ucode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "sessionId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "membershipSlug", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        Object.defineProperty(this, "marketplaceId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "membershipId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
    }
    static getInstance() {
        if (!DataHubStore.instance) {
            DataHubStore.instance = new DataHubStore();
        }
        return DataHubStore.instance;
    }
    static initData({ ucode, sessionId, membershipId, marketplaceId, membershipSlug }) {
        this.getInstance().ucode = ucode;
        this.getInstance().sessionId = sessionId;
        this.getInstance().membershipId = membershipId;
        this.getInstance().marketplaceId = marketplaceId;
        this.getInstance().membershipSlug = membershipSlug;
    }
    static resetData() {
        this.getInstance().ucode = '';
        this.getInstance().sessionId = '';
        this.getInstance().membershipId = '';
        this.getInstance().membershipSlug = '';
        this.getInstance().marketplaceId = null;
    }
    static getUcode() {
        return this.getInstance().ucode;
    }
    static getMarketplaceId() {
        if (!this.getInstance().marketplaceId) {
            throw new Error('The property marketplaceId was not initialized');
        }
        return this.getInstance().marketplaceId;
    }
    static getMembershipSlug() {
        return this.getInstance().membershipSlug;
    }
    static getMembershipId() {
        return this.getInstance().membershipId;
    }
    static getSessionId() {
        return this.getInstance().sessionId;
    }
}
